// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1jsgq","addWidgetButton":"Header_addWidgetButton__6cUPX","dashboardTabs":"Header_dashboardTabs__1AheR","active":"Header_active__1Jfft"};